import Vue from 'vue';
import dayjs from 'dayjs'
//import axios from "axios"
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'


Vue.use(dayjs)

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.guess()

Vue.filter('datestring', (value) => {
    if (!value) return null;
    return dayjs(value).tz("Asia/Kolkata").format('YYYY-MM-DD'); 

})

Vue.filter('truncate', function (datep) {
    return dayjs(datep).tz("Asia/Kolkata").format('YYYY-MM-DD'); 
});